var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuOptionsDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_delete_forever",
    "data-name": " delete_forever",
    transform: "translate(-236 -242)",
    opacity: 0.595
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 18,
    height: 18,
    transform: "translate(236 242)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.857,14H2.143A1.5,1.5,0,0,1,.714,12.445V4.667A1.5,1.5,0,0,1,2.143,3.111H7.857A1.5,1.5,0,0,1,9.286,4.667v7.778A1.5,1.5,0,0,1,7.857,14ZM5,9.652H5l1.013,1.1a.672.672,0,0,0,1.007,0,.827.827,0,0,0,0-1.1l-1.014-1.1,1.014-1.1a.827.827,0,0,0,0-1.1.672.672,0,0,0-1.007,0L5,7.459l-1.014-1.1a.672.672,0,0,0-1.007,0,.81.81,0,0,0-.209.556.791.791,0,0,0,.209.541l1.014,1.1L2.978,9.66a.827.827,0,0,0,0,1.1.672.672,0,0,0,1.007,0L5,9.653ZM9.286,2.333H.714A.749.749,0,0,1,0,1.555.749.749,0,0,1,.714.778H2.5L3.007.225A.693.693,0,0,1,3.507,0H6.493a.693.693,0,0,1,.5.225L7.5.778H9.286A.749.749,0,0,1,10,1.555.749.749,0,0,1,9.286,2.333Z",
    transform: "translate(240 244)",
    fill: "#6e6e6e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOptionsDeleteIcon);
export default __webpack_public_path__ + "static/media/menu-options-delete-icon.91fffbd69b3537fe2e25a6ec4ed8c9c7.svg";
export { ForwardRef as ReactComponent };